import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["componentEl", "children", "className", "margin", "padding"];
import React from 'react';
import { componentElDefaults, componentElPropTypes } from '../customPropTypes/componentEl';
import { addClassNames, classNamePropTypes } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes, paddingPropTypes } from '../customPropTypes/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
/*
Component to format blocks of text!!!
Not meant to wrap around other components!!!!!
*/
function Textblock(_ref) {
  var Component = _ref.componentEl,
    children = _ref.children,
    className = _ref.className,
    margin = _ref.margin,
    padding = _ref.padding,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_textblock'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    padding: padding,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_jsx(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps, {
    children: children
  }));
}
process.env.NODE_ENV !== "production" ? Textblock.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** margin for text block, if any */
  padding: paddingPropTypes
} : void 0;
Textblock.defaultProps = {
  componentEl: componentElDefaults,
  className: null,
  margin: {
    all: 'none'
  },
  padding: {
    all: 'none'
  }
};
export default Textblock;